import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Feather } from 'lucide-react';
import { WorldPageHeader } from '../../components/world/WorldPageHeader';
import { CopyLinkButton } from '../../components/guide/CopyLinkButton';
import { ValidationLegend } from '../../components/progression/ValidationBadge';
import { ClassicRecipeLabel } from '../../components/progression/RecipeSteps';
import { recipes, recipeGroups, recipePath } from '../../data/guide/recipes';

/** Índice de combinaciones fuera de alas y capas: mascotas, monturas y entradas de eventos. */
export function CombinationsGuide() {
  useEffect(() => {
    document.title = 'Combinaciones · Guía MU Vanguard';
  }, []);
  return <div className="space-y-8 md:space-y-10" data-id="element-1924" data-mp="3l87yde4s95mo">
      <WorldPageHeader crumbs={[{
      label: 'Guía',
      to: '/guia'
    }, {
      label: 'Combinaciones'
    }]} eyebrow="Guía interactiva" title="Combinaciones" data-id="element-1925" data-mp="3l4tzifvbvejz">
        <p className="mt-2 max-w-2xl text-sm text-gray-300 md:text-base" data-id="element-1926" data-mp="10fwgnes4vsi3">Cómo crear mascotas, monturas y entradas de eventos: materiales, NPC, pasos y dónde conseguir cada ingrediente.</p>
        <div className="mt-3 flex flex-wrap items-center gap-2" data-id="element-1927" data-mp="1frlarmq4hv1f">
          <ClassicRecipeLabel data-id="element-1928" data-mp="1fqacg2fg5fhp" />
          <CopyLinkButton data-id="element-1929" data-mp="1asifuv3ux576" />
        </div>
      </WorldPageHeader>

      {recipeGroups.map(g => <section key={g.id} id={g.id} aria-labelledby={`h-${g.id}`} className="scroll-mt-24" data-id="element-1930" data-mp="15uqg5ewz0esf">
          <h2 id={`h-${g.id}`} className="font-cinzel text-lg font-bold text-white md:text-xl" data-id="element-1931" data-mp="10vdwt45b5pul">{g.title}</h2>
          <p className="mt-1 text-sm text-gray-400" data-id="element-1932" data-mp="w3vqs1ofgz2r">{g.description}</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1933" data-mp="s2k341p46nx7">
            {recipes.filter(r => r.group === g.id).map(r => <li key={r.id} data-id="element-1934" data-mp="n4quz3493jua">
                <Link to={recipePath(r.id)} className="group flex h-full items-center gap-3 rounded-2xl border border-white/10 bg-[#0A1628] p-3.5 transition-colors duration-150 hover:border-[#D4AF37]/50 md:p-4" data-id="element-1935" data-mp="n1cszvzi1cnd">
                  <span className="min-w-0 flex-1" data-id="element-1936" data-mp="d7m8f26htmcy">
                    <span className="block font-cinzel font-bold text-white" data-id="element-1937" data-mp="3gw354k93lew">{r.shortTitle}</span>
                    <span className="mt-0.5 block text-xs text-gray-400 md:text-sm" data-id="element-1938" data-mp="8hjsllstzu70">{r.summary}</span>
                    <span className="mt-1 block text-[11px] text-gray-500" data-id="element-1939" data-mp="3qnooqkg7l3as">{r.machine ?? 'Chaos Machine'}</span>
                  </span>
                  <ArrowRight className="h-4 w-4 shrink-0 text-gray-500 group-hover:text-[#D4AF37]" aria-hidden="true" data-id="element-1940" data-mp="3ups3bhy6co0a" />
                </Link>
              </li>)}
          </ul>
        </section>)}

      <Link to="/guia/alas" className="group flex items-center gap-3 rounded-2xl border border-[#D4AF37]/30 bg-[#0A1628] p-4 hover:border-[#D4AF37]/60" data-id="element-1941" data-mp="dftnrwek2usm">
        <Feather className="h-5 w-5 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-1942" data-mp="hfvrsc7rk0b2" />
        <span className="flex-1" data-id="element-1943" data-mp="155yfyh8k4m4e">
          <span className="block font-cinzel font-bold text-white" data-id="element-1944" data-mp="154wt7fi6ib6u">Alas, capas y armas Chaos</span>
          <span className="block text-sm text-gray-400" data-id="element-1945" data-mp="19zubze59fywx">Arma Chaos, alas Evo 1–3, capas y Condor Feather.</span>
        </span>
        <ArrowRight className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" data-id="element-1946" data-mp="2pp1xoniuxvd5" />
      </Link>

      <p className="text-sm text-gray-400" data-id="element-1947" data-mp="2pn7lbxlnjbko">Los paquetes de joyas no se incluyen todavía: sus nombres y el NPC que los arma no están identificados en los datos de Vanguard.</p>
      <ValidationLegend data-id="element-1948" data-mp="2zfn4uzclk87o" />
    </div>;
}